export default __webpack_public_path__ + "static/media/1255.e97b2c70.jpeg";